export const LPU_NO_AVATAR_URL = '/static/_v1/pd/icons/ui-kit/photo/no-avatar-lpu.svg'

export type LpuLogoImageFile = {
  file: {
    url: string
  }
  file_format: string
}

export type LpuLogo = {
  priority_image_files?: LpuLogoImageFile[]
}

type ImgUrl = string | {
  url: string | null
}

export type LpuAvatarSource = {
  cropped_logo?: string | null
  img_50?: ImgUrl
  img_100?: ImgUrl
  img_200?: ImgUrl
  logo?: LpuLogo
}

const getUrl = (imgUrl: ImgUrl | undefined): string | null => {
  if (!imgUrl) {
    return null
  }

  return typeof imgUrl === 'string'
    ? imgUrl
    : imgUrl.url
}

export function getLpuLogoImageFiles(lpu?: { logo?: LpuLogo } | null): LpuLogoImageFile[] {
  return (lpu?.logo?.priority_image_files || []).filter(imageFile => Boolean(imageFile?.file?.url))
}

export function getLpuLogoLastFileUrl(lpu?: { logo?: LpuLogo } | null): string {
  const files = getLpuLogoImageFiles(lpu)
  const lastImageFile = files[files.length - 1]

  return lastImageFile?.file.url || LPU_NO_AVATAR_URL
}

function getAvatar({
  lpu,
  isLarge,
  isSmall,
}: {
  lpu: LpuAvatarSource
  isLarge?: boolean
  isSmall?: boolean
}) {
  if (lpu.cropped_logo) {
    return lpu.cropped_logo
  }

  const img50 = getUrl(lpu.img_50)

  if (img50 && isSmall) {
    return img50
  }

  const img100 = getUrl(lpu.img_100)

  if (img100 && !isLarge) {
    return img100
  }

  const img200 = getUrl(lpu.img_200)

  if (img200) {
    return img200
  }

  return LPU_NO_AVATAR_URL
}

export default function getLpuAvatarUrl({
  lpu,
  isLarge,
  isSmall,
  ff_update_lpu_logo,
}: {
  lpu: LpuAvatarSource
  isLarge?: boolean
  isSmall?: boolean
  ff_update_lpu_logo?: boolean
}) {
  if (ff_update_lpu_logo) {
    return getLpuLogoLastFileUrl(lpu)
  }

  const avatar = getAvatar({ lpu, isLarge, isSmall })

  return avatar.startsWith('/media/') || avatar.startsWith('/static/')
    ? avatar
    : `/media/${avatar}`
}
